<template>
  <div class="folder-tree">
    <m-folder-item
      v-for="folder in folders"
      v-bind="$attrs"
      :key="folder.id"
      :folder="folder"
    />
  </div>
</template>

<script setup>
import MFolderItem from './MFolderItem.vue'

defineProps({
  folders: {
    type: Array,
    required: true,
  },
})
</script>

<style scoped></style>
